import React, {useMemo} from 'react';
import lz from 'lzutf8';
import {Editor, Frame} from '@craftjs/core';
import {ProjectType} from 'api/generated';
import {NotFound} from 'components';

import editorResolvers from './resolvers';

interface INoCodeRendererProps {
  projectState: 'preview' | 'live';
  project: ProjectType | undefined;
  isPending: boolean;
}

const NoCodeRenderer = ({projectState, project, isPending}: INoCodeRendererProps) => {
  const state = useMemo(() => {
    if (projectState === 'preview') return project?.previewState;
    if (projectState === 'live') return project?.liveState;
  }, [projectState, project]);

  const data = useMemo(() => {
    return state?.contentToken ? (lz.decompress(lz.decodeBase64(state.contentToken)) as string) : null;
  }, [state]);

  if (isPending) {
    return null;
  }

  if (!data) {
    return <NotFound />;
  }

  return (
    <Editor enabled={false} resolver={editorResolvers}>
      <Frame data={data}></Frame>
    </Editor>
  );
};

export default React.memo(NoCodeRenderer);
